(function () {
    'use strict';

    angular.module('app').directive('fodbzDatepicker', DatePickerDirective);

    // TODO: Cleanup scope variables
    //   - Fetch fodbzLanguageCode from for example the settingsService
    //   - fodbzPlaceHolder is always the same resource
    //   - Use watchers to update lower and upper limits of selectable dates

    // CONSIDER: Create datepickers similar to month picker which directly work with ng-model and all the related machinery (validation, change detection, ...)
    // - A general datepicker with startDate, endDate and input settings
    // - A data-of-birthpicker which requires date at least 17 years in the past
    DatePickerDirective.$inject = ["habilDate",];
    function DatePickerDirective(habilDate) {
        return {
            restrict: 'E',
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                // The name of the field
                fodbzFieldConst: '@',
                // The model
                fodbzObject: '=',
                fodbzLanguageCode: '@',
                fodbzStartDate: '=',
                fodbzEndDate: '=',
                fodbzPlaceHolder: '@',
                fodbzNotRequired: '@',
                fodbzOrientation: '@',
                fodbzShouldBeAdult: '@',
                fodbzDisabled: '=',
                onChanged: '=?',
            },
            controller: DatePickerController,
            template:
                `<div ng-attr-id="div_{{fodbzFieldConst}}" class="input-group date">
                    <input type="text"
                           ng-disabled="fodbzDisabled"
                           placeholder="{{fodbzPlaceHolder}}"
                           class="form-control"
                           mask="99/99/9999"
                           ng-class="{'alert-danger': IsSameOrBefore() }">
                    <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                    </span>
                    <input type="hidden" ng-attr-id="{{fodbzFieldConst}}" ng-model="fodbzObject" name="{{fodbzFieldConst}}" ng-required="{{!fodbzNotRequired}}">
                </div>`,
            link: function ($scope, element) {

                Date.prototype.isValid = function () {
                    // An invalid date object returns NaN for getTime() and NaN is the only
                    // object not strictly equal to itself.
                    return this.getTime() === this.getTime();
                };

                const datePickerOptions = constructDatePickerOptions();

                $(element).datepicker(datePickerOptions);

                // IMPORTANT: The initialization must happen before the changeDate event is bound, otherwise we have an infinite digest-cycle
                if ($scope.fodbzObject) {
                    // Get the user timezone offset.
                    const offset = -moment($scope.fodbzObject).utcOffset();

                    // Convert to UTC time first, then add offset
                    const currentModelValueUtc = moment($scope.fodbzObject).utc();

                    const isCurrentValueValid = isValueWithinLimits(currentModelValueUtc);

                    if (isCurrentValueValid) {
                        $(element).datepicker('setUTCDate', moment(currentModelValueUtc.utcOffset(offset * -1).format('YYYY-MM-DD HH:mm:ss')).toDate());
                    }
                    else {
                        // If the current value is not within the start- and end-dates we reset the value
                        $scope.fodbzObject = null;
                    }
                }

                $(element).bind('focusout', onDateChange);
                $(element).bind('changeDate', onDateChange);
                $(element).bind('keyup', onDateChange);
                $(element).bind('keydown', onBeforeOpen);
                $(element).bind('mousedown', onBeforeOpen);

                function isValueWithinLimits(date) {
                    const startDate = moment($(element).datepicker('getStartDate')).toDate();
                    const endDate = moment($(element).datepicker('getEndDate')).toDate();

                    let isValid = true;

                    if (startDate.isValid() && startDate > date.toDate()) {
                        isValid &= false;
                    }

                    if (endDate.isValid() && endDate < date.toDate()) {
                        isValid &= false;
                    }
                    return isValid;
                }

                function onDateChange() {
                    const textBoxId = '#' + $scope.fodbzFieldConst;
                    const textBoxElement = $($(element).find(textBoxId));
                    const textBoxValue = textBoxElement.val();

                    if (textBoxValue == '') {
                        $scope.fodbzObject = null;
                    }
                    else {
                        const selectedDateVal = $(element).datepicker('getDate');

                        let selectedDate = parseDate(selectedDateVal);

                        const endDate = moment($(element).datepicker('getEndDate')).toDate();
                        if (endDate.isValid() && endDate < moment(selectedDateVal).toDate()) {
                            textBoxElement.val('');
                            $scope.fodbzObject = null;
                        }
                        else {
                            textBoxElement.val(selectedDate);
                            $scope.fodbzObject = selectedDate;
                        }
                    }

                    $scope.$apply();

                    if (angular.isFunction($scope.onChanged)) {
                        $scope.onChanged();
                    }

                    function parseDate(selectedDateVal) {
                        if (!selectedDateVal)
                            return null;

                        let selectedDate = moment(selectedDateVal).format();
                        // in this format-> 2008-09-15T15:53:00Z
                        return selectedDate.substring(0, 19) + 'Z';
                    }
                }

                function onBeforeOpen() {
                    if ($scope.fodbzShouldBeAdult)
                        return;

                    if ($scope.fodbzStartDate) {
                        // Convert to UTC time first, then add offset
                        const utcStartDate = moment($scope.fodbzStartDate).utc();

                        const newStartDate = moment(utcStartDate).toDate();
                        const currentStartDate = new Date($(element).datepicker('getStartDate'));

                        if (!currentStartDate.isValid() || newStartDate.toISOString() !== currentStartDate.toISOString())
                            $(element).datepicker('setStartDate', newStartDate);
                    }
                    else {
                        $(element).datepicker('setStartDate', getDefaultDate());
                    }

                    if ($scope.fodbzEndDate) {
                        // Convert to UTC time first, then add offset
                        const utcEndDate = moment($scope.fodbzEndDate).utc();

                        const newEndDate = moment(utcEndDate).toDate();
                        const currentEndDate = new Date($(element).datepicker('getEndDate'));

                        if (!currentEndDate.isValid() || newEndDate.toISOString() !== currentEndDate.toISOString())
                            $(element).datepicker('setEndDate', newEndDate);
                    }
                    else {
                        $(element).datepicker('setEndDate', null);
                    }
                }

                function constructDatePickerOptions() {
                    const options = {
                        language: normalizeLanguageBinding($scope.fodbzLanguageCode, 'en'),
                        format: 'dd/mm/yyyy',
                        startDate: normalizeBinding($scope.fodbzStartDate, getDefaultDate()),
                        assumeNearbyYear: true,
                        minViewMode: 0,
                        autoclose: true,
                        clearBtn: true,
                        orientation: normalizeBinding($scope.fodbzOrientation, 'top'),
                        weekStart: 1,
                    };

                    if ($scope.fodbzShouldBeAdult) {
                        const years = 17;
                        const today = habilDate.GetDateOnly(new Date());
                        const earliestDate = habilDate.SubtractYears(today, years);

                        options.endDate = earliestDate;
                    }

                    return options;

                    function normalizeLanguageBinding(value, fallback) {
                        if (value)
                            return value.toLowerCase();
                        return fallback;
                    }

                    function normalizeBinding(value, fallback) {
                        if (value)
                            return value;
                        return fallback;
                    }
                }

                function getDefaultDate() {
                    return new Date(1900, 0, 1);
                }
            },
        };
    }

    DatePickerController.$inject = ['$scope',];
    function DatePickerController($scope) {

        $scope.IsSameOrBefore = function () {
            if (!$scope.fodbzStartDate) return false;

            const selectedDateVal = $scope.fodbzObject;

            const momentDate1 = moment($scope.fodbzStartDate);
            const momentDate2 = moment(selectedDateVal);

            return momentDate2.isSameOrBefore(momentDate1);
        };
    }
})();